import * as Linking from 'expo-linking';

export default {
  prefixes: [Linking.makeUrl('/')],
  config: {
    screens: {
      Root: {
        screens: {
          Explorer: {
            screens: {
              ExplorerScreen: 'Explorer',
              ExploringScreen: 'Exploring'
            }
          },
          Oracle: {
            screens: {
              OracleScreen: 'Oracle',
              QueryingScreen: 'Querying'
            }
          },
          Settings: {
            screens: {
              SettingsScreen: 'Settings'
            }
          }
        }
      },
      NotFound: '*'
    }
  }
};
